<mat-dialog-content>
  <div class="row">
    <div class="col text-center">
      <h1>Your allocated time for this section of the mock exam has ended. You can now select from the options below:</h1>
    </div>
  </div>
  <div class="row">
    <div class="col d-flex justify-content-center">
      <button mat-raised-button class="tbp me-2" (click)="onReturnToExam()">Stay on current section</button><br>
      @if (data.currentSection === 1 && data.totalSections === 2) {
        <button mat-raised-button class="tbp" (click)="onContinue()">Move to next section</button><br>
      }
      @if (data.totalSections === 1 || (data.currentSection === data.totalSections && data.totalSections > 1)) {
        <button mat-raised-button class="tbp" (click)="onEndExam()">End Exam</button><br>
      }
    </div>
  </div>
</mat-dialog-content> 
